/** @jsxImportSource @emotion/react */
import {
  EuiPanel,
  EuiTitle,
  EuiSpacer,
  EuiText,
  EuiFlexGroup,
  EuiFlexItem,
} from "@inscopix/ideas-eui";
import { ProjectInfoBody } from "components/ProjectInfo/ProjectInfoBody";
import { ButtonIconPermissioned } from "components/ButtonIconPermissioned/ButtonIconPermissioned";
import { useDataTableContext } from "pages/gdt/store/DataTableProvider";
import { isEqual } from "lodash";

interface PanelAboutProps {
  goToSettingsTab: () => void;
}

/*
 * Project page sidebar panel with project information
 * Edit action links to settings tab
 */
export const PanelAbout = ({ goToSettingsTab }: PanelAboutProps) => {
  const project = useDataTableContext((s) => {
    const project = s.project;
    return {
      id: project.id,
      shortDescription: project.short_description,
    };
  }, isEqual);

  return (
    <EuiPanel
      hasBorder={false}
      hasShadow={false}
      paddingSize="s"
      style={{ flexGrow: "0" }}
    >
      <EuiFlexGroup responsive={false}>
        <EuiFlexItem>
          <EuiTitle size="s">
            <span>About</span>
          </EuiTitle>
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
          <ButtonIconPermissioned
            aria-label="Edit project details"
            requiredPermission="edit"
            iconType="pencil"
            onClick={goToSettingsTab}
          />
        </EuiFlexItem>
      </EuiFlexGroup>
      <EuiSpacer size="s" />
      <EuiText size="s">
        <p>{project.shortDescription}</p>
      </EuiText>
      <EuiSpacer size="s" />
      <ProjectInfoBody
        projectId={project.id}
        show={["created", "updated", "cloneSource"]}
      />
    </EuiPanel>
  );
};
